// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__cu7IT","title":"AfterBackImages_title__3RfW2","images":"AfterBackImages_images__3YJuf"};